import { render } from "./FlowVersionModal.vue?vue&type=template&id=2b601b21&scoped=true"
import script from "./FlowVersionModal.vue?vue&type=script&lang=js"
export * from "./FlowVersionModal.vue?vue&type=script&lang=js"

import "./FlowVersionModal.vue?vue&type=style&index=0&id=2b601b21&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b601b21"]])

export default __exports__